package se.mittpass.shared.auth

import kotlinx.browser.localStorage

actual class AuthStorage actual constructor() {
    private val tokenKey = "mittpass_token"
    private val refreshKey = "mittpass_refresh_token"
    private val avatarKey = "mittpass_avatar_base64"

    actual fun getToken(): String? = localStorage.getItem(tokenKey)

    actual fun setToken(token: String?) {
        if (token != null) localStorage.setItem(tokenKey, token)
        else localStorage.removeItem(tokenKey)
    }

    actual fun getRefreshToken(): String? = if (getToken() != null) "cookie" else null

    actual fun setRefreshToken(token: String?) {
        // No-op: refresh token is managed by secure HTTP-only cookie
    }

    actual fun getAvatar(): String? = localStorage.getItem(avatarKey)

    actual fun setAvatar(avatarBase64: String?) {
        if (avatarBase64 != null) localStorage.setItem(avatarKey, avatarBase64)
        else localStorage.removeItem(avatarKey)
    }

    actual fun clear() {
        localStorage.removeItem(tokenKey)
        localStorage.removeItem(avatarKey)
    }
}
